import React from "react";
import { Helmet } from "react-helmet";
import CookieConsent from "../components/CookieConsent";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../App.css";

import "./Main.css";
import { useEffect } from "react";

import { TextSectionHero } from "../components/TextSectionHero";
import { ServiceOverview } from "../components/ServiceOverview";
import Avatars from "../components/Avatars";
import { useLocation } from "react-router-dom";

import VideoBackground from "../components/VideoBackground";

import { ProjectsGrid } from "../components/ProjectsGrid";
import { InstagramFeed } from "../components/InstagramFeed";
import ParallaxSection from "../components/ParallaxSection";
import CTAWhatsApp from "../components/CTAWhatsApp";
import { TextSection, HighlightCardGrid } from "../components/ui";
import CallToActionWithModal from "../components/CallToActionWithModal";
import SplitScreenLayout from "../components/SplitScreenLayout";
import SplitScreenContent from "../components/SplitScreenContent";
import CallToActionWithModalV2 from "../components/CallToActionWithModalV2";
import ServiceMenu from "../components/ServiceMenu";
import HeroMenu from "../components/HeroMenu";
import Offers from "./Offers";
import BlogPostCarousel from "../components/BlogPostCarousel";

const dummyPosts = [
  {
    id: 1,
    title: "Porsche 911 Turbo S: Der ultimative Sportwagen-Test",
    category: "Test & Review",
    image:
      "https://res.cloudinary.com/donwh3eei/image/upload/v1756323651/gallery/frank_kayser/M10_6886_ivl5s1.jpg",
    date: "15 März 2024",
    readTime: 8,
    aspectRatio: 0.85, // Portrait - medium tall
  },
  {
    id: 2,
    title: "Restauration eines klassischen Porsche 356",
    category: "Restauration",
    image:
      "https://res.cloudinary.com/donwh3eei/image/upload/v1756323590/gallery/frank_kayser/M10_7558_taux5a.jpg",
    date: "8 März 2024",
    readTime: 12,
    aspectRatio: 1.0, // Square - baseline
  },
  {
    id: 3,
    title: "Leistungssteigerung für Porsche Boxster: Was ist möglich?",
    category: "Tuning",
    image:
      "https://res.cloudinary.com/donwh3eei/image/upload/v1756323940/gallery/cars/watercooled_marketing/1_sb3ocu",
    date: "2 März 2024",
    readTime: 6,
    aspectRatio: 0.85, // Portrait - tall
  },
  {
    id: 4,
    title: "Porsche Cayenne: Wartung und häufige Probleme",
    category: "Wartung",
    image:
      "https://res.cloudinary.com/donwh3eei/image/upload/v1756323400/gallery/frank_kayser/L1013228_yfgfsy.jpg",
    date: "25 Februar 2024",
    readTime: 10,
    aspectRatio: 0.75, // Portrait - medium
  },
  {
    id: 5,
    title: "Die Evolution der Porsche 911 Motoren",
    category: "Technik",
    image:
      "https://res.cloudinary.com/donwh3eei/image/upload/v1756323475/gallery/frank_kayser/M10_6747_mnlim4.jpg",
    date: "18 Februar 2024",
    readTime: 15,
    aspectRatio: 0.75, // Portrait - tall
  },
  {
    id: 6,
    title: "Porsche im Motorsport: Von Le Mans bis zur Formel 1",
    category: "Motorsport",
    image:
      "https://res.cloudinary.com/donwh3eei/image/upload/v1756323701/gallery/frank_kayser/M10_6908_jiwup7.jpg",
    date: "10 Februar 2024",
    readTime: 11,
    aspectRatio: 0.85, // Portrait - medium tall
  },
  {
    id: 7,
    title: "Porsche Macan: Der perfekte SUV für Enthusiasten?",
    category: "Test & Review",
    image:
      "https://res.cloudinary.com/donwh3eei/image/upload/v1756323404/gallery/frank_kayser/M10_7587_w4gz6d",
    date: "3 Februar 2024",
    readTime: 9,
    aspectRatio: 0.75, // Portrait - tall but not extreme
  },
  {
    id: 8,
    title: "Elektrifizierung bei Porsche: Der Taycan und die Zukunft",
    category: "Innovation",
    image:
      "https://res.cloudinary.com/donwh3eei/image/upload/v1756323486/gallery/frank_kayser/M10_7409_q5qdyx.jpg",
    date: "28 Januar 2024",
    readTime: 7,
    aspectRatio: 1.0, // Portrait - tall
  },
];

// Motorenbau highlight cards data
const motorenbauLinks = [
  // {
  //   headline: "Atmo 3.6 S",
  //   badge: "Stufe 1",
  //   // paragraph:
  //   //   "Eine um 280 PS starke überarbeitete Version des 964-Motors. Komplett neu aufgebaut, optisch veredelt und mit 280 PS spürbar lebendiger als Serie.",
  //   paragraph: "300 PS.  Komplett neu aufgebaut. Optisch veredelt.",
  //   url: "/motorenbau/motor-revision-356-911-964-993",
  //   image: "gallery/engine_builds/4L_product_pictures/4l-orange_retq0g",
  //   checklistItems: [
  //     "Komplette Motor-Revision",
  //     "Optische Veredelung aller Komponenten",
  //     "280 PS bei erhaltener Seriencharakteristik",
  //   ],
  // },
  {
    headline: "Motorenbau in Perfektion",
    isVideo: true,
    paragraph:
      "Erleben Sie, wie aus einem klassischen Porsche-Motor ein Meisterwerk der Ingenieurskunst entsteht. Jeder Handgriff, jedes Detail – mit Leidenschaft und Präzision gefertigt.",
    url: "/motorenbau/leistungssteigerungen",
    videoSrc:
      "https://res.cloudinary.com/donwh3eei/video/upload/ac_none,f_webm,q_auto,w_800/v1753049051/videos/porsche-motor-video_hsabsg.webm",
    posterSrc:
      "https://res.cloudinary.com/donwh3eei/image/upload/v1753049732/videos/motor-video-placeholder_paf4tf.jpg",
  },
  {
    headline: "Atmo 3.8 RS",
    badge: "Stufe 2",
    paragraph: "360 PS. 380 Nm Drehmoment. Rennsport.",
    // paragraph:
    //   "Kombiniert ein maximales Drehmoment von 380 Nm mit 330 PS Saugleistung. Entwickelt für all jene, die sportliche Momente auf der Landstraße schätzen.",
    url: "/motorenbau/leistungssteigerungen",
    image: "gallery/engine_builds/4L_product_pictures/4l-red_oaz16u",
    checklistItems: [
      "3.8L Hubraumerweiterung",
      "Titanpleuel & Rennsportkomponenten",
      "360 PS bei zugleich hoher Standfestigkeit",
      "TÜV-Gutachten & Leistungsdiagramm",
    ],
  },
  // {
  //   headline: "Atmo 4.0 RS",
  //   badge: "Stufe 3",
  //   paragraph: "400 PS. 4.0L Hubraum mit ITBs. Nervenkitzel pur.",
  //   // paragraph:
  //   //   "Nervenkitzel pur: Unser Sptizenmodell leistet 400 PS aus 4.0-Litern Hubraum - das Maximum dessen, was ein luftgekühlter Sauger sein kann.",
  //   url: "/motorenbau/leistungssteigerungen",
  //   image: "gallery/engine_builds/4L_product_pictures/4l-blue_nzeq68",

  //   checklistItems: [
  //     "4.0L mit Einzeldrosselklappen",
  //     "Titanpleuel & Rennsportkomponenten",
  //     "Bis zu 400 PS hochdrehende Performance",
  //     "TÜV-Gutachten & Leistungsdiagramm",
  //   ],
  // },
];

function Main() {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const targetElement = document.querySelector(hash);
      if (targetElement) {
        const isMobile = window.innerWidth < 1024;
        const navbarHeight = 90;
        // Simple, consistent approach for hash navigation
        setTimeout(() => {
          const elementTop = targetElement.offsetTop;
          const navbarHeight = 90;

          window.scrollTo({
            top: elementTop - navbarHeight,
            behavior: "smooth",
          });
        }, 500); // Wait for page load
      }
    }
  }, [location.hash]);

  return (
    <>
      <Helmet>
        <title>
          WTM - Freie Porsche Werkstatt | Motorenbau & Service, Inspektion &
          Restauration
        </title>
        <meta
          name="description"
          content="WTM Sportwagen: Ihre freie Porsche-Meisterwerkstatt in Gießen. Hochleistungs-Motorenbau, Motorrevisionen, Restauration, Service & Inspektion und Reparaturen für alle Porsche Modelle."
        />
        <meta
          name="keywords"
          content="Freie Porsche Werkstatt Gießen, Freie Porsche Werkstatt, Porsche Inspektion, Porsche Motorrevision, Porsche Werkstatt Gießen, Porsche Motorenbau, 911 Restauration, luftgekühlter Porsche, Porsche Service, WTM Sportwagen"
        />
        <meta
          property="og:title"
          content="WTM Sportwagen - Ihre freie Porsche Werkstatt"
        />
        <meta
          property="og:description"
          content="Ihre Porsche-Meisterwerkstatt für Motorenbau, Restauration und Service. Spezialist für luftgekühlte 911er in Gießen."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://wtm-sportwagen.com/" />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="canonical" href="https://wtm-sportwagen.com/" />
      </Helmet>
      <VideoBackground />
      <HeroMenu
        stickyHeadline="Freie Porsche Werkstatt "
        subtitle="für Enthusiasten."
        highlight="Die Zukunft ist leise, unsere Arbeit nicht."
        navbarHeight={70}
        links={[
          { label: "Motorenbau", anchor: "#motorenbau" },
          { label: "Wartung & Service", anchor: "#wartung-service" },
          { label: "Restauration", anchor: "#restauration" },
          { label: "Motorsport", anchor: "#motorsport" },
          { label: "Ankauf & Verkauf", anchor: "#aktuelle-angebote" },
        ]}
      />

      {/* <ServiceOverview navbarHeight={0} stickyHeadline="Unsere Leistungen" /> */}
      <SplitScreenLayout
        leftImage="https://res.cloudinary.com/donwh3eei/image/upload/v1735727508/gallery/frank_kayser/L1006356_imizrx"
        headline="Motorenbau bei WTM"
        navbarHeight={70}
        id="motorenbau"
        rightContent={
          <SplitScreenContent
            headline="Für luftgekühlte Porsche"
            showSvgBackground={true}
            intro="Wir bei WTM sind spezialisiert auf den Bau von <a href='/motorenbau/leistungssteigerungen' class='hyperlink'>Hochleistungs-Motoren für luftgekühlte 911</a>. Mehr Leistung? WTM."
            blocks={[
              // {
              //   type: "image",
              //   src: "gallery/frank_kayser/L1006384_1_cfl1c9",
              //   alt: "Porsche Motor Revision - Detailarbeit",
              //   width: 1200,
              //   height: 800,
              //   highQuality: true,
              // },
              // {
              //   type: "image",
              //   src: "gallery/frank_kayser/M10_6890_ztzlfu",
              //   alt: "Porsche Motor Revision - Detailarbeit",
              //   width: 1200,
              //   height: 800,
              //   highQuality: true,
              // },
              {
                type: "image",
                src: "gallery/engine_builds/964_sommerfest/IMG_0877_2_tqnesk",
                alt: "Porsche Motor Revision - Detailarbeit",
                width: 1200,
                height: 800,
                highQuality: true,
              },
              {
                type: "heading",
                text: "Motorrevision, Getriebe und Reparatur",
                level: 3,
              },

              {
                type: "paragraph",
                text: "Ob klassische 356, frühe F- und G-Modelle oder die luftgekühlten Ikonen 964 und 993 – wir bieten <a href='/motorenbau/motor-revision-356-911-964-993' class='hyperlink'>fachgerechte Motorrevision</a>, <a href='/motorenbau/getriebe-revision-911-964-993' class='hyperlink'>Getrieberevision</a> und <a href='/porsche-reparatur' class='hyperlink'>Reparaturen</a>.",
              },
              // {
              //   type: "buttons",
              //   wrapperClass:
              //     "flex flex-col sm:flex-row gap-4 mt-[-40px] mb-[80px]", // optional
              //   buttons: [
              //     {
              //       text: "Mehr erfahren", // WhatsApp-style button
              //       to: "/motorenbau/motor-revision-356-911-964-993", // internal navigation
              //       variant: "primaryInverse",
              //       size: "medium",
              //     },
              //   ],
              // },

              {
                type: "heading",
                text: "Leistungssteigerung für klassische Modelle",
                level: 3,
              },
              {
                type: "paragraph",
                text: "Als Basis nutzen wir Ihren eigenen Motor oder besorgen auf Wunsch den perfekten Spender. <a href='/motorenbau/leistungssteigerungen' class='hyperlink'>Mit akribischer Handarbeit schaffen wir ein echtes Unikat</a>.<br/>Eine kurze Übersicht bieten wir Ihnen zum <a href='/blog/964-993-leistungssteigerung' class='hyperlink'>964 / 993</a> und zum <a href='/blog/911-g-modell-leistungssteigerung' class='hyperlink'>G-Modell</a>.",
              },
              {
                type: "heading",
                text: "Für moderne wassergekühlte Modelle",
                level: 3,
              },
              {
                type: "paragraph",
                text: "Gerne übernehmen wir auch <a href='/service-wartung' class='hyperlink'>Wartung und Service</a> und <a href='/motorenbau/motor-instandsetzung-996-997-991-992' class='hyperlink'>Instandsetzung</a> Ihrer modernen Fahrzeuge - ganzgleich ob 996, 997, 991, Boxster, Cayman oder Limousine.",
              },
              // {
              //   type: "buttons",
              //   wrapperClass:
              //     "flex flex-col sm:flex-row gap-4 mt-[-40px] mb-[80px]", // optional
              //   buttons: [
              //     {
              //       text: "Mehr erfahren", // WhatsApp-style button
              //       to: "/motorenbau/leistungssteigerungen", // internal navigation
              //       variant: "primaryInverse",
              //       size: "medium",
              //     },
              //   ],
              // },

              // {
              //   type: "component",
              //   component: "CallToActionWithModalV2",
              //   props: {
              //     headline: "Mehr Leistung. Mehr Seele. Mehr Porsche.",
              //     paragraph:
              //       "Entdecken Sie unsere maßgeschneiderten Motorenbau-Lösungen für Ihren Porsche. Von der Serien-Revision bis zum High-End Performance-Motor.",
              //     darkMode: false,
              //     margin: false,
              //   },
              // },
              // {
              //   type: "image",
              //   src: "gallery/frank_kayser/M10_6838_vb1uiv",
              //   alt: "Porsche Motor Revision - Detailarbeit",
              //   width: 1200,
              //   height: 800,
              //   highQuality: true,
              //   className: "mt-24",
              // },
            ]}
          />
        }
      />
      <SplitScreenLayout
        leftImage="https://res.cloudinary.com/donwh3eei/image/upload/v1756323404/gallery/frank_kayser/M10_7587_w4gz6d"
        headline="Service & Wartung"
        navbarHeight={70}
        id="wartung-service"
        rightContent={
          <SplitScreenContent
            headline="Alles für den Porsche-Alltag"
            intro="Ob <a href='/service-wartung' class='hyperlink'>kleine Inspektion oder große Wartung</a> – wir kümmern uns mit Meisterhand um Ihren Porsche."
            blocks={[
              // {
              //   type: "image",
              //   src: "gallery/frank_kayser/M10_6861_v6tonq",
              //   alt: "Porsche Motor Revision - Detailarbeit",
              //   width: 1200,
              //   height: 800,
              //   highQuality: true,
              // },
              {
                type: "heading",
                text: "Service, Wartung und Pflege",
                level: 3,
              },

              {
                type: "paragraph",
                text: "Von luftgekühltem 911 bis zum modernen 991: Wir führen alle Servicearbeiten nach Porsche-Richtlinien durch. <a href='/service-wartung' class='hyperlink'>Detaillierte Informationen und eine Preisübersicht für Ihr Fahrzeug finden Sie hier</a>.",
              },
              {
                type: "buttons",
                wrapperClass:
                  "flex flex-col sm:flex-row gap-4 mt-[-40px] mb-[80px]", // optional
                buttons: [
                  {
                    text: "Übersicht & Buchung", // WhatsApp-style button
                    to: "/service-wartung", // internal navigation
                    variant: "secondary",
                    size: "medium",
                  },
                ],
              },
            ]}
          />
        }
      />

      <SplitScreenLayout
        leftImage="https://res.cloudinary.com/donwh3eei/image/upload/v1756323404/gallery/workshop/workshop-outside_uw6i86"
        headline="Restauration & Umbau"
        navbarHeight={70}
        id="restauration"
        rightContent={
          <SplitScreenContent
            headline="Wir bewahren, was den Porsche unsterblich macht"
            intro="Seit Jahrzehnten fasziniert der Porsche 911 mit seiner Technik, Formensprache und Fahrkultur. Damit diese Werte erhalten bleiben, braucht es Erfahrung, Sorgfalt und echtes Verständnis für jedes Detail."
            blocks={[
              // {
              //   type: "image",
              //   src: "gallery/cars/911_sc_gulf/2_twzr5q",
              //   alt: "Porsche Motor Revision - Detailarbeit",
              //   width: 1200,
              //   height: 800,
              //   highQuality: true,
              // },
              {
                type: "heading",
                text: "Restauration mit Vertrauen",
                level: 3,
              },
              {
                type: "paragraph",
                text: "Ob originalgetreu nach Werksstandard oder individuell interpretiert –  <a href='/restauration' class='hyperlink'>wir schaffen eine Restauration, die nicht nur aussieht wie neu, sondern sich auch so anfühlt</a>.<br/>Die Möglichkeiten sind vielfältig, von der Teil-Restauration bis zur Voll-Restauration. <a href='/blog/porsche-restauration-ueberblick' class='hyperlink'>Eine Übersicht finden Sie hier</a>.",
              },
              // {
              //   type: "buttons",
              //   wrapperClass:
              //     "flex flex-col sm:flex-row gap-4 mt-[-40px] mb-[80px]",
              //   buttons: [
              //     {
              //       text: "Mehr erfahren",
              //       to: "/restauration",
              //       variant: "primaryInverse",
              //       size: "medium",
              //     },
              //   ],
              // },
            ]}
          />
        }
      />

      {/* <HighlightCardGrid content={motorenbauLinks} highQuality={true} /> */}

      {/* <ParallaxSection imageUrl="/gallery/engine_builds/964_4L/P1020634_osl7du">
         <CTAWhatsApp />
       </ParallaxSection> */}

      {/* <TextSection
        margin={false}
        headline="Service & Wartung - Alles für den Porsche-Alltag"
        lead="Ob kleine Inspektion oder große Wartung – wir kümmern uns mit Meisterhand um Ihren Porsche."
        text="Von luftgekühltem 911 bis zum modernen 991: Wir führen alle Servicearbeiten nach Porsche-Richtlinien durch. Sorgfalt, Transparenz und Begeisterung für Technik – das ist WTM."
        showButtons={true}
        primaryButton={{
          text: "Übersicht & Buchung",
          variant: "secondary",
          size: "xl",
          to: "/service-wartung", // Internal route to pricing page
        }}
      /> */}
      {/* <HighlightCardGrid content={motorenbauLinks} highQuality={true} /> */}
      {/* <TextSection
        margin={true}
        headline="Restauration & Umbau - Wir begleiten Sie"
        lead="Ein Porsche erzählt Geschichte – wir lassen sie neu aufleben."
        text="Ob Werkszustand oder individueller Umbau: Wir restaurieren und veredeln mit höchstem Anspruch an Originalität, Performance und Stil. Ihr Projekt – unsere Leidenschaft."
        showButtons={true}
        primaryButton={{
          text: "Mehr zum Thema",
          variant: "secondary",
          size: "xl",
          to: "/restauration", // Internal route to pricing page
        }}
      /> */}

      <SplitScreenLayout
        leftImage="https://res.cloudinary.com/donwh3eei/image/upload/v1756323404/gallery/marketing_stock/iStock-171310367_kbikev"
        headline="Motorsport"
        navbarHeight={70}
        id="motorsport"
        rightContent={
          <SplitScreenContent
            headline="Motorsport & Trackday-Vorbereitung"
            intro="Vom Trackday bis Clubsport: Wir machen Ihren Porsche fahrdynamisch, standfest und sicher – präzise abgestimmt auf Strecke und Fahrstil."
            blocks={[
              // {
              //   type: "image",
              //   src: "gallery/cars/watercooled_marketing/1_sb3ocu",
              //   alt: "Porsche Motor Revision - Detailarbeit",
              //   width: 1200,
              //   height: 800,
              //   highQuality: true,
              // },
              {
                type: "heading",
                text: "Fahrwerk, Bremsen, Motor & Sicherheit – alles für Ihre Performance",
                level: 3,
              },
              {
                type: "paragraph",
                text: "Mit Erfahrung, Präzision und Leidenschaft sorgen wir dafür, dass Sie auf der Strecke <a href='/motorsport' class='hyperlink'>das Maximum aus Ihrem Fahrzeug holen</a> können.",
              },
              // {
              //   type: "paragraph",
              //   text: "Von der Basis-Trackday-Abstimmung bis hin zu Clubsport-Umbauten begleiten wir Sie mit maßgeschneiderten Lösungen – zuverlässig und TÜV-konform, wenn gewünscht.",
              // },
              // {
              //   type: "buttons",
              //   wrapperClass:
              //     "flex flex-col sm:flex-row gap-4 mt-[-40px] mb-[80px]",
              //   buttons: [
              //     {
              //       text: "Mehr erfahren",
              //       to: "/motorsport",
              //       variant: "primaryInverse",
              //       size: "medium",
              //     },
              //   ],
              // },
            ]}
          />
        }
      />

      <SplitScreenLayout
        leftImage="https://res.cloudinary.com/donwh3eei/image/upload/v1756323404/gallery/frank_kayser/M10_7409_1_moquhk"
        headline="Ankauf & Verkauf"
        navbarHeight={70}
        id="aktuelle-angebote"
        rightContent={
          <SplitScreenContent
            headline="Aktuelle Angebote"
            intro="<a href='/aktuelle-angebote' class='hyperlink'>Entdecken Sie unsere handverlesenen Porsche-Klassiker und Youngtimer</a>. Jedes Fahrzeug wird von uns sorgfältig geprüft und aufbereitet."
            blocks={[
              {
                type: "component",
                component: "OfferCardDeck",
                props: { className: "mb-8 sm:mb-20" },
              },
              {
                type: "heading",
                text: "Geprüfte Qualität",
                level: 3,
              },
              {
                type: "paragraph",
                text: " Transparenz und Ehrlichkeit stehen bei uns an erster Stelle – Sie erhalten eine detaillierte Dokumentation des Fahrzeugzustands.",
              },
              {
                type: "buttons",
                wrapperClass:
                  "flex flex-col sm:flex-row gap-4 mt-[-40px] mb-[80px]",
                buttons: [
                  {
                    text: "Alle Angebote",
                    to: "/aktuelle-angebote",
                    variant: "primaryInverse",
                    size: "medium",
                  },
                ],
              },
              {
                type: "heading",
                text: "Ihr Porsche zum Verkauf?",
                level: 3,
              },
              {
                type: "paragraph",
                text: "<a href='/porsche-verkaufen' class='hyperlink'>Wir bieten Ihnen eine professionelle Bewertung und unterstützen Sie beim Verkauf</a>. Von der Aufbereitung bis zur Vermarktung – alles aus einer Hand.",
              },
              {
                type: "buttons",
                wrapperClass:
                  "flex flex-col sm:flex-row gap-4 mt-[-40px] mb-[80px]",
                buttons: [
                  {
                    text: "Fahrzeug bewerten lassen",
                    to: "/porsche-verkaufen",
                    variant: "secondary",
                    size: "medium",
                  },
                ],
              },
            ]}
          />
        }
      />

      {/* <Offers
        carousel={true}
        showHeadline={false}
        headline="Fahrzeuge zum Verkauf"
        subscript="Aktuelle Angebote"
        renderNavigateButton={false}
      /> */}

      {/* <ProjectsGrid
        renderStickyHeadline={true}
        stickyHeadline="Aktuelles aus der Werkstatt"
        navbarHeight={70}
      /> */}
      <BlogPostCarousel darkMode={true} />
      {/* <Avatars stickyHeadline="Das Team hinter WTM" navbarHeight={0} /> */}

      <InstagramFeed
        maxHeight="500px"
        darkMode={true}
        stickyHeadline="Folgen Sie uns"
        navbarHeight={70}
      />
      <CookieConsent />
    </>
  );
}

export default Main;
